import { render, staticRenderFns } from "./measure-set.vue?vue&type=template&id=22f8df96"
import script from "./measure-set.vue?vue&type=script&lang=js"
export * from "./measure-set.vue?vue&type=script&lang=js"
import style0 from "./measure-set.vue?vue&type=style&index=0&id=22f8df96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports